(() => {
  if (location.search.includes('contact_posted=true')) {
  document.documentElement.style.scrollBehavior = 'auto';

  window.addEventListener('load', () => {
    const inquiry = document.getElementById('work-with-me');

    if (inquiry) {
      inquiry.scrollIntoView({
        behavior: 'auto',
        block: 'start'
      });
    }

    setTimeout(() => {
      document.documentElement.style.scrollBehavior = '';
    }, 300);
  });
}
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  // Mobile navigation
  const toggle = qs('[data-mobile-toggle]');
  const panel = qs('[data-mobile-panel]');
  if (panel) document.body.appendChild(panel);
  if (toggle && panel) {
  toggle.addEventListener('click', () => {
    const open = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  });

  panel.addEventListener('click', (event) => {
    if (event.target.closest('a')) {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });
}

  // Scroll reveal: fade in from below as content enters the viewport while scrolling down.
  const reveal = qsa('.reveal-down');
  reveal.forEach((el, i) => {
    if (!el.style.getPropertyValue('--reveal-delay')) {
      el.style.setProperty('--reveal-delay', `${Math.min(i % 5, 4) * 55}ms`);
    }
  });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      }),
      { threshold: 0.08, rootMargin: '0px 0px -4% 0px' }
    );
    reveal.forEach(el => io.observe(el));
  } else {
    reveal.forEach(el => el.classList.add('is-visible'));
  }

  // Partnership attribution: carries UTM tags from outreach emails into Shopify's contact notification.
  const params = new URLSearchParams(location.search);
  qsa('[data-utm-field]').forEach(field => {
    const key = field.dataset.utmField;
    field.value = params.get(key) || sessionStorage.getItem(`ggnm_${key}`) || '';
    if (params.get(key)) sessionStorage.setItem(`ggnm_${key}`, params.get(key));
  });
  qsa('[data-referrer-field]').forEach(field => {
    field.value = document.referrer || sessionStorage.getItem('ggnm_referrer') || '';
    if (document.referrer) sessionStorage.setItem('ggnm_referrer', document.referrer);
  });
  ['utm_source', 'utm_medium', 'utm_campaign'].forEach(key => {
    if (params.get(key)) sessionStorage.setItem(`ggnm_${key}`, params.get(key));
  });
  if (document.referrer && !sessionStorage.getItem('ggnm_referrer')) {
    sessionStorage.setItem('ggnm_referrer', document.referrer);
  }

  // Analytics dashboard. Expected endpoint shape is documented in the separate integration package.
  qsa('[data-analytics-dashboard]').forEach(async dash => {
    const endpoint = dash.dataset.endpoint;
    const status = qs('[data-analytics-status]', dash);
    const updated = qs('[data-analytics-updated]', dash);
    const dot = qs('[data-analytics-connection-dot]', dash);
    if (!endpoint) {
      if (updated) updated.textContent = 'Live feed not configured';
      return;
    }

    const fmt = value => {
      if (value === null || value === undefined || value === '') return '—';
      const n = Number(value);
      if (Number.isNaN(n)) return value;
      return Intl.NumberFormat('en-US', {
        notation: Math.abs(n) >= 10000 ? 'compact' : 'standard',
        maximumFractionDigits: 1
      }).format(n);
    };
    const pct = value => {
      if (value === null || value === undefined || value === '') return '—';
      const n = Number(value);
      return Number.isNaN(n) ? value : `${n.toFixed(1)}%`;
    };
    const set = (key, value) => {
      qsa(`[data-live-value="${key}"]`, dash).forEach(el => {
        el.textContent = key.toLowerCase().includes('rate') ? pct(value) : fmt(value);
      });
    };
    const setDelta = (key, value) => {
      qsa(`[data-live-delta="${key}"]`, dash).forEach(el => {
        if (value === null || value === undefined || value === '') return;
        const n = Number(value);
        if (Number.isNaN(n)) {
          el.textContent = value;
          return;
        }
        el.textContent = `${n >= 0 ? '+' : ''}${n.toFixed(1)}% vs prior period`;
        el.classList.toggle('is-negative', n < 0);
      });
    };

    const refreshAnalytics = async () => {
      try {
        const refreshUrl = new URL(endpoint, window.location.origin);
        refreshUrl.searchParams.set('_live', Date.now().toString());

        const res = await fetch(refreshUrl.toString(), {
          headers: { Accept: 'application/json' },
          credentials: endpoint.startsWith('/') ? 'same-origin' : 'omit',
          cache: 'no-store'
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        ['totalAudience','views30d','avgVideoViews','reach30d','engagements30d','engagementRate','posts30d'].forEach(k => set(k, data[k]));
        ['totalAudienceDelta','views30dDelta','reach30dDelta','engagements30dDelta'].forEach(k => setDelta(k, data[k]));

        if (data.platforms) {
          Object.entries(data.platforms).forEach(([name, platform]) => {
            Object.entries(platform || {}).forEach(([k, v]) => set(`${name}.${k}`, v));
          });
        }

        // Lifetime cumulative totals for the exact series groups configured in the Worker.
        if (data.series) {
          qsa('[data-series-card]').forEach(card => {
            const series = data.series?.[card.dataset.seriesCard];
            if (!series || series.complete === false) return;

            const viewsEl = qs('[data-series-stat="views"]', card);
            const engagementsEl = qs('[data-series-stat="engagements"]', card);

            if (viewsEl && series.views !== null && series.views !== undefined) {
              viewsEl.textContent = fmt(series.views);
            }
            if (engagementsEl && series.engagements !== null && series.engagements !== undefined) {
              engagementsEl.textContent = fmt(series.engagements);
            }

            card.classList.add('is-live');
          });
        }

        if (updated) {
          updated.textContent = data.updatedAt
            ? `Updated ${new Date(data.updatedAt).toLocaleString()}`
            : 'Live feed connected';
        }
        if (status) status.textContent = 'Live platform feed connected.';
        if (dot) {
          dot.classList.remove('is-offline');
          dot.classList.add('is-live');
        }
        dash.classList.add('is-live');
      } catch (err) {
        console.warn('GGNM analytics feed unavailable:', err);
        if (updated) updated.textContent = 'Live feed awaiting connection';
        if (status) status.textContent = 'Secure feed not connected yet — showing theme fallback values.';
        if (dot) {
          dot.classList.remove('is-live');
          dot.classList.add('is-offline');
        }
      }
    };

    // Load immediately, then re-check the live Worker every 5 minutes.
    await refreshAnalytics();
    if (!dash.dataset.liveRefreshStarted) {
      dash.dataset.liveRefreshStarted = 'true';
      window.setInterval(refreshAnalytics, 5 * 60 * 1000);
    }
  });

  // Per-Reel portfolio performance. Supports a future secure analytics payload with
  // `posts` or `recentContent` items shaped like:
  // { id: "Dc0VyQAz_Ga", url: "https://...", views: 123000, engagements: 5400, engagementRate: 4.4, updatedAt: "..." }
  qsa('[data-social-portfolio]').forEach(async portfolio => {
    const endpoint = portfolio.dataset.endpoint;
    const cards = qsa('[data-reel-id]', portfolio);
    if (!endpoint || !cards.length) return;

    const fmtReel = value => {
      if (value === null || value === undefined || value === '') return null;
      const n = Number(value);
      if (Number.isNaN(n)) return String(value);
      return Intl.NumberFormat('en-US', {
        notation: Math.abs(n) >= 10000 ? 'compact' : 'standard',
        maximumFractionDigits: 1
      }).format(n);
    };
    const fmtRate = value => {
      if (value === null || value === undefined || value === '') return null;
      const n = Number(value);
      return Number.isNaN(n) ? String(value) : `${n.toFixed(1)}%`;
    };
    const normalize = value => String(value || '').replace(/\?.*$/, '').replace(/\/$/, '').toLowerCase();

    try {
      const res = await fetch(endpoint, {
        headers: { Accept: 'application/json' },
        credentials: endpoint.startsWith('/') ? 'same-origin' : 'omit',
        cache: 'no-store'
      });
      if (!res.ok) return;
      const data = await res.json();
      const posts = Array.isArray(data.posts)
        ? data.posts
        : Array.isArray(data.recentContent)
          ? data.recentContent
          : Array.isArray(data?.platforms?.instagram?.posts)
            ? data.platforms.instagram.posts
            : [];
      if (!posts.length) return;

      cards.forEach(card => {
        const reelId = normalize(card.dataset.reelId);
        const reelUrl = normalize(card.dataset.reelUrl);
        const match = posts.find(post => {
          const id = normalize(post.id || post.shortcode || post.mediaId);
          const url = normalize(post.url || post.permalink);
          return (id && id === reelId) || (url && url === reelUrl) || (url && reelId && url.includes(reelId));
        });
        if (!match) return;

        const values = {
          views: fmtReel(match.views ?? match.videoViews ?? match.plays),
          engagements: fmtReel(match.engagements ?? match.interactions ?? match.totalInteractions),
          engagementRate: fmtRate(match.engagementRate ?? match.engagement_rate)
        };
        Object.entries(values).forEach(([key, value]) => {
          if (!value) return;
          const el = qs(`[data-reel-stat="${key}"]`, card);
          if (el) {
            el.textContent = value;
            el.classList.add('is-live-value');
          }
        });

        const updated = qs('[data-reel-updated]', card);
        if (updated) {
          updated.textContent = match.updatedAt
            ? `Updated ${new Date(match.updatedAt).toLocaleDateString()}`
            : 'Live performance';
        }
        card.classList.add('is-live');
      });
    } catch (err) {
      console.warn('GGNM per-Reel analytics unavailable:', err);
    }
  });

  
  
})();

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-external-url]');
  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();

  var url = trigger.getAttribute('data-external-url');
  if (!url) return;

  // Open the social destination in a separate tab only.
  // Never redirect the Shopify/storefront tab.
  var popup = window.open(url, '_blank');
  if (popup) {
    try { popup.opener = null; } catch (e) {}
  }
});
